import { Check, ChevronsUpDown, Building2 } from "lucide-react";
import { useCurrentOrganization } from "@/lib/org";
import { useOrgStore } from "@/stores/orgStore";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useNavigate } from "react-router-dom";

export function OrganizationSwitcher() {
  const { organization, memberships, loading } = useCurrentOrganization();
  const setCurrentOrgId = useOrgStore((s) => s.setCurrentOrgId);
  const navigate = useNavigate();

  if (loading) return <Skeleton className="h-9 w-48" />;
  if (!organization) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-9 gap-2 px-2.5 -ml-2.5 hover:bg-secondary"
        >
          <Building2 className="h-4 w-4 text-muted-foreground" />
          <span className="font-semibold text-foreground">
            {organization.name}
          </span>
          <span className="text-xs text-muted-foreground hidden sm:inline">
            {organization.country_code} · {organization.default_currency}
          </span>
          <ChevronsUpDown className="h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-72">
        <DropdownMenuLabel className="text-xs text-muted-foreground">
          Your organizations
        </DropdownMenuLabel>
        {memberships.map((m) => {
          const active = m.organization_id === organization.id;
          return (
            <DropdownMenuItem
              key={m.organization_id}
              onClick={() => setCurrentOrgId(m.organization_id)}
              className="gap-2"
            >
              <Building2 className="h-4 w-4 text-muted-foreground" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">
                  {m.organization.name}
                </div>
                <div className="text-xs text-muted-foreground capitalize">
                  {m.role} · {m.organization.subscription_tier}
                </div>
              </div>
              {active && <Check className="h-4 w-4 text-primary" />}
            </DropdownMenuItem>
          );
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/onboarding")}>
          Create new organization
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
